// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_42-6";
export var headerCell = "_42-2";
export var rowWrapper = "_42-4";
export var stickyAggregationCell = "_42-a";
export var stickyAggregationRow = "_42-7";
export var stickyColumnCell = "_42-9";
export var stickyColumnHeaderCell = "_42-8";
export var table = "_42-1";
export var virtualRowWrapper = "_42-5";
export var virtualTableContainer = "_42-0";
export var white = "_42-3";